import Api from '@/utils/api';
import homeAcademy from '@/components/home/homeAcademy/index.vue';
import homeKnowledgeBaseProofreader from '@/components/home/knowledge/proofreader.vue';
import homeKnowledgeBaseQaexpert from '@/components/home/knowledge/qaexpert.vue';
import homeKnowledgeBaseProjectmanager from '@/components/home/knowledge/projectmanager.vue';
import homeKnowledgeBaseCustomer from '@/components/home/knowledge/customer.vue';
import homeQuestionsAnswers from '@/components/home/homeQuestionsAnswers/index.vue';
import homeSupport from '@/components/home/homeSupport/index.vue';

import helpers from '@/mixins/helpers';

export default {
  components: {
    homeAcademy,
    homeKnowledgeBaseProofreader,
    homeKnowledgeBaseQaexpert,
    homeKnowledgeBaseProjectmanager,
    homeKnowledgeBaseCustomer,
    homeQuestionsAnswers,
    homeSupport,
  },
  mixins: [
    helpers.general,
  ],
  data() {
    return {
      notificationList: [],
      currentNotifications: null,
      hiddenNotifications: [],
    };
  },
  computed: {
    homeAcademy() {
      return this.checkPermissions('home', 'home-academy');
    },
    homeKnowledgeProofreader() {
      return this.checkPermissions('home', 'home-knowledge-base-proofreader');
    },
    homeKnowledgeQaexpert() {
      return this.checkPermissions('home', 'home-knowledge-base-qaexpert');
    },
    homeKnowledgeProjectmanager() {
      return this.checkPermissions('home', 'home-knowledge-base-projectmanager');
    },
    homeKnowledgeCustomer() {
      return this.checkPermissions('home', 'home-knowledge-base-customer');
    },
    homeSupport() {
      return this.checkPermissions('home', 'home-support');
    },
    homeQuestionsAnswers() {
      return this.checkPermissions('home', 'home-questions-answers');
    },
  },
  methods: {
    checkNotifications() {
      this.currentNotifications = this.notificationList.filter((el) => {
        const now = Date.now();
        const nowStr = `${new Date(now).getDay()} ${new Date(now).getFullYear()} ${new Date(now).getMonth()}`;
        const elementDayStr = `${new Date(el.EndDate).getDay()} ${new Date(el.EndDate).getFullYear()} ${new Date(el.EndDate).getMonth()}`;
        return nowStr === elementDayStr;
      });
      this.currentNotifications.length === 0 ? this.currentNotifications = null : this.currentNotifications = this.currentNotifications;
    },
    getNotifications() {
      Api.settings
        .notifications
        .getNotifications()
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            this.notificationList = res.data;
            this.notificationList.forEach((el) => {
              el.StartDate = new Date((el.StartDate * 1000));
              el.EndDate = new Date((el.EndDate * 1000));
            });
            this.checkNotifications();
          }
        }).catch((err) => {
          this.$root.$emit('notification', {
            message: `error | ${err.Message}`,
            type: 'error',
            show: true,
          });
        });
    },
    pushHiddenNotification(ID) {
      this.currentNotifications = this.currentNotifications.filter((el) => {
        return el.ID !== ID;
      });
      this.hiddenNotifications.push(this.currentNotifications.find((el) => el.ID === ID));
      this.currentNotifications.length === 0 ? this.currentNotifications = null : this.currentNotifications = this.currentNotifications;
    },
  },
  created() {
    this.getNotifications();
  },
};
